export default __webpack_public_path__ + "static/media/servicing.d6021aaf.svg";